import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDynamicNode } from './TypedNode'
import { SchemaDynamicModel } from './ViewModel'

export const SchemaDynamicPlugin = createSchemaPlugin(
  'Schema.Dynamic',
  SchemaDynamicModel,
  SchemaDynamicNode
)
